import { ButtonProps } from "@/components/ui/button";

type ImageProps = {
  src: string;
  alt?: string;
};

type Props = {
  heading: string;
  description: string;
  buttons: ButtonProps[];
  logos: ImageProps[];
};

export type CertificationSectionProps =
  React.ComponentPropsWithoutRef<"section"> & Partial<Props>;

export const CertificationSection = (props: CertificationSectionProps) => {
  const { heading, description, logos } = {
    ...CertificationSectionDefaults,
    ...props,
  };
  return (
    <section id="certificacoes" className="py-12 md:py-16 lg:py-20 bg-white">
      <div className="container">
        <div className="grid grid-cols-1 items-center justify-center">
          <div className="mx-auto mb-12 max-w-3xl text-center">
            <h2 className=" text-n-primary rb-5 mb-5 text-3xl font-semibold md:mb-6 md:text-4xl lg:text-5xl">
              {heading}
            </h2>
            <p className="md:text-lg text-n-text-neutral font-light">
              {description}
            </p>
          </div>

          <div className="flex flex-row flex-wrap w-full items-center justify-center gap-2 md:px-[10%]">
            {logos.map((logo, index) => (
              <div
                key={index}
                className="2xl:max-w-[304px] max-w-[280px] sxl:h-[100px] h-[84px] flex w-full items-start justify-center rounded-lg justify-self-center bg-n-bg-2 hover:bg-neutral-100 hover:shadow-sm px-4 pb-4 pt-[0.875rem] md:p-[0.875rem]"
              >
                <img
                  src={logo.src}
                  className="max-h-12 md:max-h-14  self-center"
                  alt={logo.alt}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export const CertificationSectionDefaults: Props = {
  heading: "Reconhecimentos e certificações",
  description:
    "Comprometidos com a qualidade dos nossos serviços, buscamos níveis de excelência e reconhecimento de plataformas de avaliações de serviço, como obtemos certificações por órgãos reguladores.",
  buttons: [
    { title: "Button", variant: "green" },
    {
      title: "Button",
      variant: "link",
      size: "sm",
    },
  ],
  logos: [
    {
      src: "/images/certificado-reclame-aqui.png",
      alt: "Certificado reclame aqui",
    },
    {
      src: "/images/google.png",
      alt: "Google nota 5",
    },
    {
      src: "/images/reclame-aqui.png",
      alt: "Reclame aqui",
    },
    {
      src: "/images/antt.png",
      alt: "Certificado Antt",
    },
    {
      src: "/images/ssl.png",
      alt: "Certificado SSL",
    },
  ],
};
